var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Documents',{attrs:{"uploadUrl":_vm.uploadUrl,"data-documents":_vm.company.documents,"title":"Upload Company Documents","extraFields":{ type: 'company' }}})
}
var staticRenderFns = []

export { render, staticRenderFns }